import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  UpdateClassificationActions as Actions,
  UpdateClassificationRequestAction as RequestAction,
} from 'store/ducks/classifications';

export function* updateClassificationRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(putData);
    yield call(api.put, `classifications/${id}`, formData);
    onSuccess && onSuccess();
    notify('success', 'Classificação atualizada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
